import * as React from 'react';
import { Provider } from 'react-redux';
import * as PropTypes from 'prop-types';

import { IConfig } from '@cian/config/shared';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';

import { IReduxStore } from '../../types/redux';
import { ICustomContextParams } from '../../types/ICustomContextParams';

import { PageContainer } from '../PageContainer';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: IReduxStore;
  customContext: ICustomContextParams;
}

export type TApplicationContextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export class Application extends React.Component<IApplicationProps> {
  // TODO: переделать на React Context API
  public static childContextTypes: TApplicationContextTypes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    config: PropTypes.object as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logger: PropTypes.object as any,
  };

  public constructor(props: IApplicationProps) {
    super(props);
  }

  // TODO: переделать на React Context API
  public getChildContext(): IApplicationContext {
    return {
      config: this.props.config,
      logger: this.props.logger,
    };
  }

  public render() {
    const { logger, reduxStore } = this.props;

    return (
      <ErrorLogComponent logger={logger}>
        <Provider store={reduxStore}>
          <PageContainer />
        </Provider>
      </ErrorLogComponent>
    );
  }
}
